var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AnonymousLayout',[_c('p',[_vm._v("Validando firma.")]),(_vm.message)?_c('span',{staticClass:"mt-4",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }